import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

const Fields = ({ reasons, input, meta: { touched, error } }) => {
  const [selected, setSelected] = useState('')

  useEffect(() => {
    input.onChange(selected)
  }, [selected])

  return (
    <div className="my-5">
      <ul>
        {reasons.map((reason, key) => (
          <li className={`mb-1 bg-white py-3 text-center text-lg cursor-pointer ${selected === reason && 'bg-primary-orange text-white'}`} key={key} onClick={() => setSelected(reason)}>{reason}</li>
        ))}
      </ul>
      <div className="bg-white py-3 px-2 flex mt-5">
        <span className="mx-2">Other:</span>
        <input type="text" className="w-full text-primary-lightgray" onChange={e => setSelected(e.target.value.trim())} />
      </div>
      {touched && error && <p className={`text-action-danger mt-3`}>{error}</p>}
    </div>
  )
}

Fields.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  reasons: PropTypes.array,
}

export default Fields
